import { render, staticRenderFns } from "./CommonPageEdit.vue?vue&type=template&id=16cbc3d2&scoped=true"
import script from "./CommonPageEdit.vue?vue&type=script&lang=js"
export * from "./CommonPageEdit.vue?vue&type=script&lang=js"
import style0 from "./CommonPageEdit.vue?vue&type=style&index=0&id=16cbc3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cbc3d2",
  null
  
)

export default component.exports